export default {
  uploadingFiles: [],
};
